import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;

function authHeaders(token) {
  return { Authorization: `Bearer ${token}` };
}

function strutturaParams(strutturaId) {
  return strutturaId ? { strutturaId } : {};
}

export async function getLayout(token, strutturaId = null) {
  const res = await axios.get(`${API_URL}/api/fatturazione/layout`, {
    headers: authHeaders(token),
    params: strutturaParams(strutturaId),
  });
  return res.data;
}

export async function saveLayout(token, layoutData, strutturaId = null) {
  const payload = {
    ...layoutData,
    strutturaId: strutturaId ?? layoutData.strutturaId ?? null,
  };
  const res = await axios.put(`${API_URL}/api/fatturazione/layout`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

/** tipo: "principale" (logo intestazione) | "footer" (logo piè di pagina, template Fatture in Cloud) */
export async function uploadLogo(token, file, strutturaId = null, tipo = "principale") {
  const formData = new FormData();
  formData.append("logo", file);
  formData.append("tipo", tipo);
  if (strutturaId) formData.append("strutturaId", strutturaId);
  const res = await axios.post(`${API_URL}/api/fatturazione/layout/logo`, formData, {
    headers: {
      ...authHeaders(token),
      "Content-Type": "multipart/form-data",
    },
    params: strutturaParams(strutturaId),
  });
  return res.data;
}

export async function deleteLogo(token, strutturaId = null, tipo = "principale") {
  const res = await axios.delete(`${API_URL}/api/fatturazione/layout/logo`, {
    headers: authHeaders(token),
    params: { ...strutturaParams(strutturaId), tipo },
  });
  return res.data;
}

export async function anteprimaPdf(token, layout, fascicoloId = null, voci = null, strutturaId = null) {
  const normalizedTemplate = String(layout?.template || "classico").toLowerCase();
  const body = {
    layout: {
      ...layout,
      template: normalizedTemplate,
      strutturaId: strutturaId ?? layout?.strutturaId ?? null,
    },
  };
  if (fascicoloId) body.fascicolo_id = fascicoloId;
  if (voci) body.voci = voci;
  const res = await axios.post(`${API_URL}/api/fatturazione/layout/anteprima-pdf`, body, {
    headers: authHeaders(token),
    params: strutturaParams(strutturaId ?? layout?.strutturaId),
    responseType: "blob",
  });
  return res.data;
}
